import { base } from '../../utils';

export const getFollowers = async (userId) => {
  try {
    const url = `/v1/users/${userId}/followers`;

    const response = await base.get(url);
    return response.data;
  } catch (error) {
    throw new Error(error);
  }
};
